import { useCallback, useEffect, useRef, useState } from "react";

export const MATCHING_GIVE_UP_MS = 90000;

export const matchesTabTitle = (total) => {
  const count = Number(total) || 0;
  return count > 0 ? `Matches (${count})` : "Matches";
};

const useMatchingProgress = ({
  serverStatus,
  hasMatches = false,
  onFinished,
  giveUpAfterMs = MATCHING_GIVE_UP_MS,
}) => {
  const [status, setStatus] = useState(serverStatus || null);
  const [gaveUp, setGaveUp] = useState(false);
  const previous = useRef(serverStatus || null);
  const onFinishedRef = useRef(onFinished);

  useEffect(() => {
    onFinishedRef.current = onFinished;
  }, [onFinished]);

  useEffect(() => {
    if (serverStatus === undefined) return;
    setStatus(serverStatus || null);
    setGaveUp(false);
  }, [serverStatus]);

  const isAwaitingResult = status === "processing" && !gaveUp;

  useEffect(() => {
    if (!isAwaitingResult) return undefined;
    const timer = setTimeout(() => setGaveUp(true), giveUpAfterMs);
    return () => clearTimeout(timer);
  }, [isAwaitingResult, giveUpAfterMs]);

  useEffect(() => {
    if (previous.current === "processing" && status === "complete") {
      onFinishedRef.current?.();
    }
    previous.current = status;
  }, [status]);

  const markComplete = useCallback(() => setStatus("complete"), []);

  return {
    isMatchingInProgress: isAwaitingResult && !hasMatches,
    isAwaitingResult,
    markComplete,
  };
};

export default useMatchingProgress;
